<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon } from "@getprovi/craft-svelte";
  import { BoxArrowUpRight } from "@getprovi/craft-svelte-icons";
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import {
    createAccountEvent,
    loginEvent,
  } from "@shared/services/retailer_user_authentication_service";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import { OHLQ_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  const dispatch = createEventDispatcher();

  function changeStatus() {
    dispatch("continue");
  }

  function toQueryString(params) {
    return Object.entries(params)
      .flatMap(([key, value]) =>
        Array.isArray(value)
          ? value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
          : `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
      )
      .join("&");
  }

  let ohlqSignupParamsString = "";
  $: {
    let user = $CurrentUserStore;
    let ohlqRegisterParams: {
      firstname: string;
      lastname: string;
      emailaddress: string;
      phonenumber?: string;
    } = {
      firstname: user.first_name,
      lastname: user.last_name,
      emailaddress: user.email,
    };

    if (user.phone) {
      ohlqRegisterParams.phonenumber = String(user.phone);
    }

    ohlqSignupParamsString = "?" + toQueryString(ohlqRegisterParams);
  }
</script>

<div class="flex flex-column items-center">
  <img
    src="https://portal.ohlq.com/Portals/0/OHLQ_2_color_horizontal_TM.jpg?ver=2019-07-29-112714-850"
    alt="OHLQ"
    style="max-width: 147px;"
  />
  <h2 class="flex-1 text-center fizz-stack-32" style="max-width: 220px;">
    We've partnered with OHLQ!
  </h2>
</div>
<div class="bg-neutral rounded-sm fizz-inset-horizontal-16 fizz-inset-vertical-24 fizz-stack-32">
  <h4 class="fizz-text-strong text-center fizz-stack-24">
    <p>Connect Your</p>
    <p>Wholesale Cloud Account</p>
  </h4>
  <p class="text-center fizz-text-subdued fizz-stack-4">Have an account for:</p>
  <p class="text-center fizz-text-strong fizz-stack-16">{$CurrentRetailerStore.name}?</p>
  <div class="flex gap-16 justify-center">
    <a
      class="craft-button btn-primary btn-base cursor-pointer justify-center"
      data-testid="ohlq-log-in-link"
      href="https://portal.ohlq.com/eCommerce-Login?returnurl=%2fMy-Account#/account"
      rel="noreferrer"
      target="_blank"
      on:click={() => {
        loginEvent("pending", OHLQ_DISTRIBUTOR_ID, { step: "intro" });
        changeStatus();
      }}
    >
      <span class="btn-text flex gap-4">Log In <Icon iconName={BoxArrowUpRight} /></span>
    </a>
    <a
      class="craft-button btn-secondary btn-base cursor-pointer justify-center"
      data-testid="ohlq-create-account-link"
      href="https://portal.ohlq.com/e4Register-Business{ohlqSignupParamsString}"
      rel="noreferrer"
      target="_blank"
      on:click={() => {
        createAccountEvent("pending", OHLQ_DISTRIBUTOR_ID, { step: "intro" });
        changeStatus();
      }}
    >
      <span class="btn-text flex gap-4">
        Create Account
        <Icon iconName={BoxArrowUpRight} />
      </span>
    </a>
  </div>
</div>
<p
  class="fizz-text-subdued fizz-inset-horizontal-16 fizz-stack-64 fizz-text-large fizz-text-center"
>
  Next, you'll be asked for your API Key found in the 'Profile' section of your WSC account.
</p>
<div class=" fizz-text-subdued fizz-inset-horizontal-16">
  <p class="text-center">
    <span class="fizz-text-strong">Need help?</span> Contact OHLQ Liquor Enterprise Service Center
    at
    <a href="tel:+18778120013">877-812-0013</a>
  </p>
</div>
